import React from 'react';
import block from 'bem-cn-lite';
import {Col, Row} from '@yandex-data-ui/page-constructor';

import {NavigationItemExtended} from 'models/app';
import {DefaultCategorizedItemSizes, List} from 'units/navigation/models';
import NavigationCardItem from 'units/navigation/components/NavigationCardItem/NavigationCardItem';

import './ListMCards.scss';

const b = block('list-m-cards');

const ListMCards: React.FC<List> = ({navigationItems, type}) => (
    <Row>
        {navigationItems.map((item: NavigationItemExtended) => (
            <Col key={item.slug} className={b('item')} sizes={DefaultCategorizedItemSizes}>
                <NavigationCardItem item={item} key={item.slug} type={type} />
            </Col>
        ))}
    </Row>
);
export default ListMCards;
